export default "__VITE_ASSET__BGs8SZZk__"